import { render } from "./TemplateVnfSettings.vue?vue&type=template&id=e51889ac&scoped=true"
import script from "./TemplateVnfSettings.vue?vue&type=script&lang=js"
export * from "./TemplateVnfSettings.vue?vue&type=script&lang=js"

import "./TemplateVnfSettings.vue?vue&type=style&index=0&id=e51889ac&lang=less&scoped=true"

import exportComponent from "/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e51889ac"]])

export default __exports__